import { gql } from '@lcs/shared/api';

export const getActiveCallLogsQuery = gql`
   query GetActiveCallLogs($first: Int!, $filters: String, $after: String, $orderingOptions: [OrderingOption!]) {
      activeCallsConnection(first: $first, filters: $filters, after: $after, orderingOptions: $orderingOptions) {
         totalCount
         pageInfo {
            hasNextPage
            endCursor
            hasPreviousPage
            startCursor
         }
         items {
            callDetailId
            account {
               accountId
               name
            }
            sourceExtension {
               extensionId
               number
               name
            }
            destinationExtension {
               extensionId
               number
               name
            }
            callRecording {
               callRecordingId
               file {
                  fileId
                  fileToken
                  fileName
                  displayName
               }
            }
            callSegmentsConnection {
               items {
                  callSegmentId
                  callDetailId
                  sourceExtensionId
                  extensionId
                  sourceExtension {
                     extensionId
                     extensionType {
                        name
                     }
                     name
                     number
                  }
                  extension {
                     extensionId
                     extensionType {
                        name
                     }
                     name
                     number
                  }
                  startDate
                  duration
               }
            }
            callDispositionTypeName
            callDirectionTypeName
            destinationNumber
            callDispositionTypeId
            callDirectionTypeId
            startTime
            sourceExtensionId
            sourceNumber
            destinationExtensionId
            destinationNumber
            originalDestinationNumber
            phoneNumber {
               phoneNumberId
               phoneNumber
            }
            callerName
            callRate
            serverName
            sipCallId
            providerId
            sourceProviderId
            destinationProviderId
            callRecordingCallDetailConnection {
               items {
                  callRecordingCallDetailId
                  callRecordingId
                  callDetailId
                  callRecording {
                     file {
                        fileId
                        fileToken
                        fileName
                        displayName
                     }
                  }
               }
            }
         }
      }
   }
`;
